"use client";

import { motion } from "framer-motion";
import { Award, Flame, Dumbbell, Coffee, MapPin, Building2 } from "lucide-react";
import SectionHeading from "components/ui/SectionHeading";
import { BENEFITS_FULL } from "lib/constants";
import { staggerContainer, staggerItem } from "lib/utils";

const ICONS = {
  Award: <Award className="w-8 h-8 text-Mora-caramel" />,
  Flame: <Flame className="w-8 h-8 text-Mora-caramel" />,
  Dumbbell: <Dumbbell className="w-8 h-8 text-Mora-caramel" />,
  Coffee: <Coffee className="w-8 h-8 text-Mora-caramel" />,
  MapPin: <MapPin className="w-8 h-8 text-Mora-caramel" />,
  Building2: <Building2 className="w-8 h-8 text-Mora-caramel" />
};

export default function BenefitsGrid() {
  return (
    <section className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white border-t border-Mora-caramel/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-20">
        <SectionHeading
          eyebrow="WHAT MAKES US DIFFERENT"
          title="The Mora Difference"
          subtitle="Honest quality, traditional craftsmanship, and thoughtful modern execution in every single batch"
          className="mb-8 sm:mb-12 md:mb-14"
        />

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "0px 0px -40px 0px" }}
        >
          {BENEFITS_FULL.map((benefit, index) => {
            const icon = ICONS[benefit.icon] || ICONS.Award;
            return (
              <motion.div
                key={index}
                variants={staggerItem}
                className="group relative bg-Mora-ivory p-5 sm:p-6 md:p-8 rounded-xl sm:rounded-2xl border border-Mora-beige shadow-sm hover:shadow-xl transition-all duration-500 ease-out hover:-translate-y-1.5 overflow-hidden h-full flex flex-col"
              >
                <div className="absolute top-0 left-0 w-full h-1 bg-Mora-caramel transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 ease-out origin-left"></div>
                <div className="mb-4 sm:mb-6 bg-white w-12 sm:w-14 md:w-16 h-12 sm:h-14 md:h-16 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-500 ease-out shadow-sm border border-Mora-caramel/10">
                  {icon}
                </div>
                <h3 className="font-heading text-lg sm:text-xl md:text-2xl text-Mora-dark mb-2 sm:mb-3 group-hover:text-Mora-caramel transition-colors font-semibold">
                  {benefit.title}
                </h3>
                <p className="font-body text-Mora-brown/80 text-sm sm:text-base leading-relaxed">
                  {benefit.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
